<template>
  <button 
    class="arrow-button"
    :title="title"
  >
    <svg 
      v-if="direction === 'up'" 
      class="arrow-icon" 
      viewBox="0 0 15 10" 
      fill="currentColor"
    >
      <path d="M8.27208 0.94413C7.87651 0.51861 7.20282 0.51861 6.80725 0.94413L0.841647 7.36147C0.246966 8.00118 0.700635 9.04233 1.57406 9.04233L13.5053 9.04233C14.3787 9.04233 14.8324 8.00118 14.2377 7.36147L8.27208 0.94413Z"/>
    </svg>
    <svg 
      v-else 
      class="arrow-icon" 
      viewBox="0 0 15 10" 
      fill="currentColor"
    >
      <path d="M8.27208 9.05587C7.87651 9.48139 7.20282 9.48139 6.80725 9.05587L0.841647 2.63853C0.246966 1.99882 0.700635 0.957673 1.57406 0.957674L13.5053 0.957675C14.3787 0.957675 14.8324 1.99882 14.2377 2.63853L8.27208 9.05587Z"/>
    </svg>
  </button>
</template>

<script>
export default {
  name: 'ArrowButton',
  props: {
    direction: {
      type: String,
      default: 'down',
      validator: value => ['up', 'down'].includes(value)
    },
    // text: {
    //   type: String,
    //   default: '詳細'
    // },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.arrow-button {
  background: none;
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 0px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  color: #000000;
}

.arrow-icon {
  width: 15px;
  height: 10px;
  fill: #3C3C3C;
  opacity: 1;
}

.arrow-text {
  font-size: 12px;
  font-weight: 500;
  color: #3c3c3c;
}
</style> 